import { Box, Tab } from "@material-ui/core";
import { TabContext, TabList } from "@material-ui/lab";
import useCustomState from "../../hooks/State";
import NoData from "../BillsFilter/NotFound";
import ModuleTable from "./ModuleTable";
const ModuleTabBox = ({ types, devices }) => {
  const TabValue = useCustomState(0);
  const TabPanelData = useCustomState([]);
  const changeTab = (e, newValue) => {
    TabValue.handleChange(newValue);
    TabPanelData.handleChange(
      devices.filter(
        (device) =>
          device.water_meter_type_info.water_meter_type_id ===
          types[newValue].water_meter_type_id
      )
    );
  };
  return (
    <TabContext value={TabValue.value}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabList onChange={changeTab}>
          {types.map((item, idx) => (
            <Tab
              label={item?.water_meter_type_name}
              value={idx}
              key={item?.water_meter_type_id}
            />
          ))}
        </TabList>
      </Box>
      <Box>
        {TabPanelData.value.length > 0 ? (
          <ModuleTable data={TabPanelData.value} />
        ) : (
          <NoData message={"این ماژول در پروژه موجود نیست"} />
        )}
      </Box>
    </TabContext>
  );
};
export default ModuleTabBox;
